// Add your custom JS here.


// Initialize Swiper – Homepage

  var swiper = new Swiper(".homeSwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });





// Scripts with jQuery dependency
(function($){
	$(document).ready(function($){ 



    // Mobile hamburger button – toggle class
    $(".navbar-toggler").click(function(){
      $(this).toggleClass("open");
    });

    // Mouseover archive post permalink, add class to feature image

      $('a.permalink').hover(
          function() {
              $(this).closest('article').find('.archive-thumb').toggleClass('zoom');
          }
      );


      // Add class to the last top-level exhibitor to create space between the next level
      $('li.L').last().after('<li class="clearfix"></li>');



      // Creates a tabbed content effect for the exhibits page
      $('.btn-grid').on('click', function() {
        if ($('section.exhibits').hasClass('list')) {
          $('section.exhibits').removeClass('list');
        }
      });

      $('.btn-list').on('click', function() {
        if (!$('section.exhibits').hasClass('list')) {
          $('section.exhibits').addClass('list');
        }
      });



      // Exhibits: Navigating to previous and next modal windows 

      $(document).ready(function() {
        // Handle the "Prev" button click
        $('.btn-prev').on('click', function() {
          // Find the current open modal
          var currentModal = $(this).closest('.modal');
          
          // Close the current modal
          currentModal.modal('hide');
          
          // Find the previous modal
          var prevModal = currentModal.closest('li').prevAll().find('.modal').first();
          
          // Open the previous modal if it exists
          if (prevModal.length) {
            prevModal.modal('show');
          }
        });
      
        // Handle the "Next" button click
        $('.btn-next').on('click', function() {
          // Find the current open modal
          var currentModal = $(this).closest('.modal');
          
          // Close the current modal
          currentModal.modal('hide');
          
          // Find the next modal
          var nextModal = currentModal.closest('li').nextAll().find('.modal').first();
          
          // Open the next modal if it exists
          if (nextModal.length) {
            nextModal.modal('show');
          }
        });
      
        // Handle the "Close" button click
        $('.close').on('click', function() {
          // Close the current modal
          $(this).closest('.modal').modal('hide');
        });
      });
      





      jQuery(window).scroll(function() {
        var $el = jQuery('#back-top');
        
        if(jQuery(this).scrollTop() >= 400) $el.addClass('show');
        else $el.removeClass('show');
      });



	});
})( jQuery );
// End Scripts with jQuery dependency



